import Vue from "vue";
import Router from "vue-router";
import Index from "../components/Index";
import Fruit from "../components/Fruit";
import Fashion from "../components/Fashion";
import AboutUs from "../components/aboutUs.vue";

Vue.use(Router);

export default new Router({
  mode: "history", // 设置使用History模式
  redirect: "/",
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index,
    },
    {
      path: "/fruit",
      name: "Fruit",
      component: Fruit,
    },
    {
      path: "/fashion",
      name: "Fashion",
      component: Fashion,
    },
    {
      path: "/aboutUs",
      name: "aboutUs",
      component: AboutUs,
    },
  ],
});
